  import React, { useContext, useEffect, useMemo, useState } from "react";
  import { useParams, Link, useSearchParams } from "react-router-dom";
  import API from "../api/api";
  import { AuthContext } from "../context/AuthContext";

  const API_BASE = "https://warfc.com/api";

  const typeLabel = (type) =>
    type === "altan_garaa" ? "АЛТАН ГАРАА" : "ҮНДСЭН";

  const genderLabel = (gender) =>
    gender === "female" ? "ЭМЭГТЭЙ" : "ЭРЭГТЭЙ";

  const weightSortValue = (value) => {
    const text = String(value || "").trim();
    const plus = text.startsWith("+");
    const number = Number(text.replace(/[^0-9.]/g, ""));
    return Number.isFinite(number) ? number + (plus ? 100000 : 0) : 999999;
  };

  const ageSortValue = (value) => {
    const first = Number(String(value || "").match(/\d+/)?.[0]);
    return Number.isFinite(first) ? first : 999;
  };

  const safeNumber = (value) => {
    if (value === null || value === undefined) {
      return null;
    }

    if (typeof value === "string" && value.trim() === "") {
      return null;
    }

    const n = Number(value);

    return Number.isFinite(n) && n > 0 ? n : null;
  };

  const getWeight = (match, slot) => {
    const prefix = slot === 1 ? "fighter1" : "fighter2";

    const value =
      match?.[`${prefix}_actual_weight`] ??
      match?.[`${prefix}`]?.actual_weight ??
      null;

    return safeNumber(value);
  };

  const getFighterId = (match, slot) => {
    const prefix = slot === 1 ? "fighter1" : "fighter2";
    return (
      match?.[`${prefix}_id`] ??
      match?.[`${prefix}`]?.fighter_id ??
      null
    );
  };

  const getFighterName = (match, slot) => {
    const prefix = slot === 1 ? "fighter1" : "fighter2";
    const fighter = match?.[prefix];

    return (
      match?.[`${prefix}_name`] ||
      [fighter?.name, fighter?.surname].filter(Boolean).join(" ") ||
      null
    );
  };

  const getClubName = (match, slot) => {
    const prefix = slot === 1 ? "fighter1" : "fighter2";
    const fighter = match?.[prefix];

    return (
      match?.[`${prefix}_club_name`] ||
      match?.[`${prefix}_club`] ||
      fighter?.club_name ||
      fighter?.club ||
      ""
    );
  };

  const getClubLogo = (match, slot) => {
    const prefix = slot === 1 ? "fighter1" : "fighter2";
    const fighter = match?.[prefix];
    return match?.[`${prefix}_club_logo`] || fighter?.club_logo || "";
  };

  const getFighterPhoto = (match, slot) => {
    const prefix = slot === 1 ? "fighter1" : "fighter2";
    const fighter = match?.[prefix];

    return (
      match?.[`${prefix}_photo_url`] ||
      match?.[`${prefix}_photo`] ||
      match?.[`${prefix}_image_url`] ||
      match?.[`${prefix}_image`] ||
      fighter?.photo_url ||
      fighter?.photo ||
      fighter?.image_url ||
      fighter?.image ||
      ""
    );
  };

  const getPhotoUrl = (photo) => {
    if (!photo) return "";
    if (String(photo).startsWith("http")) return photo;
    if (String(photo).startsWith("/")) return `${API_BASE}${photo}`;
    return `${API_BASE}/${String(photo).replace(/^\/+/, "")}`;
  };

  const getWinnerId = (match) => match?.winner_id ?? match?.winner ?? null;

  const isWinner = (match, fighterId) => {
    const winner = getWinnerId(match);
    return winner != null && Number(winner) === Number(fighterId);
  };

  const getLogoUrl = (logo) => {
    if (!logo) return `${API_BASE}/uploads/clubs/default-club.png`;
    if (String(logo).startsWith("http")) return logo;
    if (String(logo).startsWith("/")) return `${API_BASE}${logo}`;
    return `${API_BASE}/uploads/clubs/${logo}`;
  };

    const getFightNumber = (match) => {
    return (
      match?.fight_number ??
      match?.fight_no ??
      match?.fightNumber ??
      null
    );
  };

  const getRingNumber = (match) => {
    return (
      match?.ring_number ??
      match?.ring_no ??
      match?.ringNumber ??
      match?.ring ??
      null
    );
  };

  const BRACKET_CARD_WIDTH = 292;
  const BRACKET_CARD_HEIGHT = 216;
  const BRACKET_ROW_GAP = 32;
  const BRACKET_COLUMN_GAP = 96;
  const BRACKET_TOP = 58;

  const BRACKET_STEP =
    BRACKET_CARD_HEIGHT + BRACKET_ROW_GAP;

  function FighterSlot({ match, slot }) {
    const fighterId = getFighterId(match, slot);
    const name = getFighterName(match, slot);
    const club = getClubName(match, slot);
    const logo = getClubLogo(match, slot);
    const photo = getFighterPhoto(match, slot);
    const weight = getWeight(match, slot);
    const winner = fighterId && isWinner(match, fighterId);
    const red = slot === 1;

    if (!fighterId) {
      return (
        <div className="px-4 py-4 text-neutral-700 text-[10px] font-black uppercase tracking-widest">
          BYE / TBD
        </div>
      );
    }

    return (
      <div
        className={`relative px-4 py-3.5 overflow-hidden transition-all ${
          winner
            ? "bg-gradient-to-r from-[#d4af37]/20 via-[#d4af37]/10 to-transparent"
            : "bg-neutral-950/70"
        } ${red ? "border-b border-neutral-900" : ""}`}
      >
        {/* CLUB LOGO — SMALL + ZOOMED */}
{logo && (
  <div className="absolute inset-0 flex items-center justify-end pr-2 pointer-events-none overflow-hidden">
    <div className="w-14 h-14 rounded-full overflow-hidden bg-black/10 border border-white/[0.07]">
      <img
        src={getLogoUrl(logo)}
        alt=""
          className="w-full h-full object-contain p-0.5 scale-125 opacity-[0.15] grayscale"
      />
    </div>
  </div>
)}

        {/* CORNER ACCENT */}
        <div
          className={`absolute left-0 top-0 bottom-0 w-1 ${
            winner
              ? "bg-[#d4af37]"
              : red
              ? "bg-red-600/70"
              : "bg-blue-600/70"
          }`}
        />

        <div className="relative z-10 flex items-center gap-3 min-w-0">
          {/* FIGHTER PROFILE PHOTO */}
          <div
  className={`relative w-11 h-11 rounded-xl overflow-hidden shrink-0 border ${
    winner
      ? "border-[#d4af37]"
      : red
      ? "border-red-500/60"
      : "border-blue-500/60"
  } bg-neutral-900 shadow-lg`}
>
            {photo ? (
              <img
                src={getPhotoUrl(photo)}
                alt=""
                className="w-full h-full object-cover"
                onError={(event) => {
                  event.currentTarget.style.display = "none";
                }}
              />
            ) : (
              <div className="w-full h-full flex items-center justify-center text-neutral-700 text-lg font-black">
                {red ? "R" : "B"}
              </div>
            )}

            {/* subtle photo overlay */}
            <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent pointer-events-none" />
          </div>

          {/* FIGHTER INFO */}
          <div className="min-w-0 flex-1">
            <div
              className={`flex items-center gap-2 ${
                winner ? "text-[#f6d76b]" : "text-white"
              }`}
            >
              <span className="text-xs md:text-sm font-black uppercase truncate">
                {name || "TBD"}
              </span>

              {winner && (
                <span className="text-[#d4af37] text-sm shrink-0">✓</span>
              )}
            </div>

            <div className="text-[9px] text-neutral-500 font-bold uppercase tracking-wider truncate mt-0.5">
              {club || "Club not listed"}
            </div>
          </div>

          {/* ACTUAL WEIGHT */}
          {weight != null && (
            <span className="text-[10px] font-black text-[#d4af37] shrink-0">
              {weight.toFixed(1)}kg
            </span>
          )}
        </div>
      </div>
    );
  }

  function MatchCard({
    match,
    roundIndex,
    totalRounds,
    isAdmin,
    savingWinner,
    onSelectWinner,
    onChangeResult,
    pathActive = false,
  }) {
    const matchId = match?.match_id ?? match?.id;
    const final = roundIndex === totalRounds - 1;
    const winner = getWinnerId(match);
    const completed = winner != null;

    const fighter1Id = getFighterId(match, 1);
    const fighter2Id = getFighterId(match, 2);
    const bothFighters = fighter1Id && fighter2Id;

    const fightNumber = getFightNumber(match);
    const ringNumber = getRingNumber(match);

    return (
      <div
        className={`relative w-[292px] shrink-0 rounded-2xl overflow-hidden border bg-[#080808]/95 shadow-2xl transition-all ${
          isAdmin ? "min-h-[216px]" : "min-h-[150px]"
        } ${
          final
            ? "border-[#d4af37]/80 shadow-[0_0_40px_rgba(212,175,55,0.18)]"
            : pathActive
            ? "border-[#d4af37]/35 shadow-[0_0_25px_rgba(212,175,55,0.08)]"
            : completed
            ? "border-neutral-700"
            : "border-neutral-800 hover:border-neutral-600"
        }`}
      >
        <div className="flex items-center justify-between px-4 py-2 bg-white/[0.025] border-b border-neutral-900">
    <div className="flex items-center gap-3 min-w-0">
      {fightNumber != null && (
        <span className="text-[9px] font-black tracking-[0.18em] text-neutral-400 uppercase whitespace-nowrap">
          FIGHT {fightNumber}
        </span>
      )}

      {ringNumber != null && (
        <>
          <span className="text-neutral-700">•</span>

          <span className="text-[9px] font-black tracking-[0.16em] text-[#d4af37] uppercase whitespace-nowrap">
            RING {ringNumber}
          </span>
        </>
      )}
    </div>

  </div>

        <FighterSlot match={match} slot={1} />
        <FighterSlot match={match} slot={2} />

        {isAdmin && bothFighters && (
          <div className="border-t border-neutral-900 bg-black/60 p-2">
            {!completed ? (
              <div className="grid grid-cols-2 gap-2">
                <button
                  type="button"
                  disabled={savingWinner === matchId}
                  onClick={() => onSelectWinner(match, fighter1Id)}
                  className="rounded-lg py-2 text-[9px] font-black uppercase tracking-wider bg-red-950/40 text-red-300 hover:bg-red-900/70 disabled:opacity-50"
                >
                  {savingWinner === matchId ? "SAVING..." : "🔴 WINNER"}
                </button>

                <button
                  type="button"
                  disabled={savingWinner === matchId}
                  onClick={() => onSelectWinner(match, fighter2Id)}
                  className="rounded-lg py-2 text-[9px] font-black uppercase tracking-wider bg-blue-950/40 text-blue-300 hover:bg-blue-900/70 disabled:opacity-50"
                >
                  {savingWinner === matchId ? "SAVING..." : "🔵 WINNER"}
                </button>
              </div>
            ) : (
              <button
                type="button"
                onClick={() => onChangeResult(match)}
                className="w-full rounded-lg py-2 text-[9px] font-black uppercase tracking-[0.16em] border border-[#d4af37]/40 text-[#d4af37] hover:bg-[#d4af37]/10 transition"
              >
                CHANGE RESULT
              </button>
            )}
          </div>
        )}
      </div>
    );
  }

  function ChampionPanel({ champion, category, onShare }) {
  const championId = champion?.fighter_id ?? champion?.id;
  const name = champion?.name || "CHAMPION TBD";
  const club = champion?.club_name || champion?.club || "";
  const image =
    champion?.photo_url ||
    champion?.photo ||
    champion?.image_url ||
    champion?.image ||
    "";

  const clubLogo = champion?.club_logo || "";

  return (
    <aside className="w-full xl:w-[350px] shrink-0">
      <div className="relative overflow-hidden rounded-3xl border border-[#d4af37]/50 bg-[#070707] shadow-[0_0_60px_rgba(212,175,55,0.14)]">

        {/* GOLD BACKGROUND GLOW */}
        <div className="absolute inset-0 pointer-events-none">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_5%,rgba(212,175,55,0.28),transparent_45%),linear-gradient(145deg,#181208,#070707_52%,#0b0b0b)]" />

          <div className="absolute -top-24 left-1/2 -translate-x-1/2 w-72 h-72 rounded-full bg-[#d4af37]/10 blur-3xl" />

          <div className="absolute -bottom-24 -left-20 w-56 h-56 rounded-full bg-[#d4af37]/[0.06] blur-3xl" />

          <div className="absolute -bottom-24 -right-20 w-56 h-56 rounded-full bg-[#d4af37]/[0.06] blur-3xl" />
        </div>

        {/* CLUB LOGO WATERMARK */}
        {clubLogo && (
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none overflow-hidden translate-y-20">
            <div className="w-[290px] h-[290px] rounded-full overflow-hidden border border-[#d4af37]/10 bg-black/10">
              <img
                src={getLogoUrl(clubLogo)}
                alt=""
                className="w-full h-full object-contain p-7 opacity-[0.13] grayscale"
              />
            </div>
          </div>
        )}

        {/* CONTENT */}
        <div className="relative z-10 p-5">

          {/* CROWN */}
          <div className="text-center">
            <div className="text-5xl leading-none mb-2 text-[#d4af37] drop-shadow-[0_0_18px_rgba(212,175,55,0.65)]">
              ♛
            </div>

            <div className="text-[10px] font-black tracking-[0.38em] text-[#d4af37] uppercase">
              CHAMPION
            </div>

            <div className="mt-1 text-[9px] font-bold tracking-[0.22em] text-neutral-500 uppercase">
              2026 KICKBOXING NATIONAL CHAMPIONSHIP
            </div>
          </div>

          {/* FIGHTER PORTRAIT */}
          <div className="relative mx-auto mt-5 w-[190px] h-[220px]">

            {/* outer gold glow */}
            <div className="absolute inset-0 rounded-2xl bg-[#d4af37]/10 blur-xl" />

            {/* frame */}
            <div className="relative w-full h-full rounded-2xl overflow-hidden border-2 border-[#d4af37]/70 bg-black shadow-[0_0_35px_rgba(212,175,55,0.22)]">

              {/* club logo behind fighter */}
              {clubLogo && (
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                  <img
                    src={getLogoUrl(clubLogo)}
                    alt=""
                    className="w-[155px] h-[155px] object-contain opacity-[0.10] grayscale"
                  />
                </div>
              )}

              {/* gold portrait gradient */}
              <div className="absolute inset-0 bg-gradient-to-t from-black via-black/20 to-transparent z-10 pointer-events-none" />

              {image ? (
                <img
                  src={getPhotoUrl(image)}
                  alt={name}
                  className="relative z-0 w-full h-full object-cover object-top"
                />
              ) : (
                <div className="relative z-0 w-full h-full flex items-center justify-center">
                  <span className="text-6xl opacity-40">🥊</span>
                </div>
              )}

              {/* bottom gold shine */}
              <div className="absolute bottom-0 left-0 right-0 h-20 bg-gradient-to-t from-[#d4af37]/15 to-transparent z-20 pointer-events-none" />
            </div>
          </div>

          {/* NAME */}
          <div className="mt-5 text-center">
            <div className="text-[26px] leading-tight font-black italic uppercase tracking-wide text-white">
              {name}
            </div>

            {club && (
              <div className="mt-1.5 text-[10px] font-black uppercase tracking-[0.25em] text-[#d4af37]">
                {club}
              </div>
            )}
          </div>

          {/* CATEGORY INFO */}
          <div className="mt-5 flex flex-wrap justify-center gap-2 text-[9px] font-black uppercase tracking-widest">

            <span className="px-3 py-1.5 rounded-full bg-[#d4af37]/10 border border-[#d4af37]/30 text-[#e7c85b]">
              {genderLabel(category?.gender)}
            </span>

            <span className="px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-neutral-300">
              {category?.age_division}
            </span>

            <span className="px-3 py-1.5 rounded-full bg-white/5 border border-white/10 text-neutral-300">
              {category?.weightclass_name}
            </span>

          </div>

          {/* TITLE */}
          <div className="mt-6 text-center">
            <div className="flex items-center justify-center gap-3">
              <div className="h-px w-10 bg-gradient-to-r from-transparent to-[#d4af37]/50" />

              <span className="text-[10px] font-black uppercase tracking-[0.28em] text-[#d4af37]">
                🏆 TOURNAMENT CHAMPION
              </span>

              <div className="h-px w-10 bg-gradient-to-l from-transparent to-[#d4af37]/50" />
            </div>

            <div className="mt-2 text-[9px] text-neutral-500 font-bold uppercase tracking-[0.22em]">
              WAR FC • KICKBOXING NATIONAL CHAMPIONSHIP
            </div>
          </div>

          {/* SHARE */}
          {championId && (
            <button
              type="button"
              onClick={() => onShare({ championId, name, club })}
              className="mt-6 w-full rounded-xl py-3.5 bg-gradient-to-r from-[#d4af37] to-[#f0cf62] text-black text-[10px] font-black uppercase tracking-[0.2em] hover:brightness-110 transition shadow-[0_8px_25px_rgba(212,175,55,0.20)]"
            >
              ↗ SHARE YOUR VICTORY
            </button>
          )}

          <button
            type="button"
            onClick={() =>
              onShare({
                championId,
                name,
                club,
                facebook: true,
              })
            }
            className="mt-2 w-full rounded-xl py-3 border border-neutral-700 text-neutral-300 text-[9px] font-black uppercase tracking-[0.18em] hover:border-[#d4af37]/50 hover:text-white transition"
          >
            f&nbsp;&nbsp; SHARE TO FACEBOOK
          </button>

        </div>
      </div>
    </aside>
  );
}

  export default function BracketShow() {
    const { tournamentId } = useParams();
    const [searchParams, setSearchParams] = useSearchParams();
    const { user } = useContext(AuthContext);
    const isAdmin = user?.role === "admin";

    const [bracketsByCategory, setBracketsByCategory] = useState({});
    const [selectedCategory, setSelectedCategory] = useState(() => searchParams.get("category") || "");
    const [selectedType, setSelectedType] = useState("");
    const [selectedGender, setSelectedGender] = useState("");
    const [selectedAge, setSelectedAge] = useState("");
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState("");
    const [savingWinner, setSavingWinner] = useState(null);

    const fetchBrackets = async (silent = false) => {
      try {
        if (!silent) setLoading(true);
        setError("");

        const res = await API.get(`/tournaments/${tournamentId}/brackets`);
        const rawData = res?.data ?? res;
        const bracketList = Array.isArray(rawData)
          ? rawData
          : Array.isArray(rawData?.data)
          ? rawData.data
          : Array.isArray(rawData?.brackets)
          ? rawData.brackets
          : [];

        const registrationRes = await API.get(`/tournaments/${tournamentId}/registration`).catch(() => null);
        const rawRegistration = registrationRes?.data ?? registrationRes;
        const registrations = Array.isArray(rawRegistration)
          ? rawRegistration
          : Array.isArray(rawRegistration?.fighters)
          ? rawRegistration.fighters
          : Array.isArray(rawRegistration?.data)
          ? rawRegistration.data
          : [];

        const fighterWeightMap = {};
        registrations.forEach((fighter) => {
          const id = safeNumber(fighter?.fighter_id ?? fighter?.id);
          const weight = safeNumber(fighter?.actual_weight);
          if (id && weight != null) fighterWeightMap[id] = weight;
        });

        const results = await Promise.allSettled(
          bracketList.map(async (summary) => {
            const bracketId = summary?.bracket_id ?? summary?.id;
            if (!bracketId) return null;

            const detailRes = await API.get(`/brackets/${bracketId}`);
            const detail = detailRes?.data ?? detailRes;

            return {
              ...summary,
              ...detail,
              bracket_id: detail?.bracket_id ?? detail?.id ?? bracketId,
              matches: (detail?.matches || []).map((match) => ({
                ...match,
                id: match.id ?? match.match_id,
                bracket_id: match.bracket_id ?? bracketId,
                fighter1_id: match.fighter1_id ?? match.fighter1?.fighter_id ?? null,
                fighter2_id: match.fighter2_id ?? match.fighter2?.fighter_id ?? null,
                fighter1_actual_weight:
                  match.fighter1_actual_weight ?? fighterWeightMap[Number(match.fighter1_id ?? match.fighter1?.fighter_id)] ?? null,
                fighter2_actual_weight:
                  match.fighter2_actual_weight ?? fighterWeightMap[Number(match.fighter2_id ?? match.fighter2?.fighter_id)] ?? null,
              })),
            };
          })
        );

        const categoryMap = {};

        results
          .filter((result) => result.status === "fulfilled" && result.value)
          .forEach(({ value: bracket }) => {
            const categoryId = String(
              bracket.category_id ?? bracket.division_weightclass_id ?? bracket.bracket_id
            );

            if (!categoryMap[categoryId]) {
              categoryMap[categoryId] = {
                category_id: bracket.category_id ?? bracket.division_weightclass_id,
                bracket_id: bracket.bracket_id ?? bracket.id,
                category_label:
                  bracket.category_label ||
                  `${typeLabel(bracket.type)} | ${genderLabel(bracket.gender)} | ${bracket.age_division || ""} | ${bracket.weightclass_name || ""}`,
                division_weightclass_id: bracket.division_weightclass_id,
                division_id: bracket.division_id,
                age_division: bracket.age_division,
                weightclass_name: bracket.weightclass_name,
                gender: bracket.gender,
                type: bracket.type,
                status: bracket.status,
                rounds: {},
              };
            }

            (bracket.matches || []).forEach((match) => {
              const round = Number(match.round ?? match.round_number ?? 1);
              if (!categoryMap[categoryId].rounds[round]) {
                categoryMap[categoryId].rounds[round] = [];
              }
              categoryMap[categoryId].rounds[round].push(match);
            });
          });

        const finalMap = Object.fromEntries(
          Object.entries(categoryMap).map(([id, category]) => [
            id,
            {
              ...category,
              rounds: Object.entries(category.rounds)
                .sort(([a], [b]) => Number(a) - Number(b))
                .map(([, matches]) =>
                  matches.sort(
                    (a, b) =>
                      Number(a.match_index ?? a.match_number ?? 0) -
                      Number(b.match_index ?? b.match_number ?? 0)
                  )
                ),
            },
          ])
        );

        setBracketsByCategory(finalMap);
        const ids = Object.keys(finalMap);
        const requestedCategory = searchParams.get("category");

        setSelectedCategory((current) => {
          if (current && finalMap[current]) return current;
          if (requestedCategory && finalMap[requestedCategory]) return requestedCategory;
          return ids[0] || "";
        });
      } catch (err) {
        console.error("Error loading brackets:", err);
        setError(
          err?.response?.data?.error ||
            err?.response?.data?.message ||
            err?.message ||
            "Bracket ачаалахад алдаа гарлаа."
        );
      } finally {
        if (!silent) setLoading(false);
      }
    };

    useEffect(() => {
    if (tournamentId) fetchBrackets();
  }, [tournamentId]);

  const categoryList = useMemo(
    () => Object.values(bracketsByCategory),
    [bracketsByCategory]
  );

  const typeOptions = useMemo(() => {
    const types = [...new Set(categoryList.map((c) => c.type).filter(Boolean))];

    return [
      ...types.filter((type) => type !== "altan_garaa"),
      ...types.filter((type) => type === "altan_garaa"),
    ];
  }, [categoryList]);

  const genderOptions = useMemo(
    () =>
      [
        ...new Set(
          categoryList
            .filter((c) => !selectedType || c.type === selectedType)
            .map((c) => c.gender)
            .filter(Boolean)
        ),
      ],
    [categoryList, selectedType]
  );

  const ageOptions = useMemo(
    () =>
      [
        ...new Set(
          categoryList
            .filter((c) => !selectedType || c.type === selectedType)
            .filter((c) => !selectedGender || c.gender === selectedGender)
            .map((c) => c.age_division)
            .filter(Boolean)
        ),
      ].sort((a, b) => ageSortValue(a) - ageSortValue(b)),
    [categoryList, selectedType, selectedGender]
  );

  useEffect(() => {
    if (!categoryList.length) return;

    // 1. Default TYPE → ҮНДСЭН
    if (!selectedType && typeOptions.length) {
      const mainType =
        typeOptions.find((type) => type !== "altan_garaa") ||
        typeOptions[0];

      setSelectedType(mainType);
      return;
    }

    // 2. Default GENDER → ЭРЭГТЭЙ
    if (!selectedGender && genderOptions.length) {
      const male =
        genderOptions.find((gender) => gender === "male") ||
        genderOptions[0];

      setSelectedGender(male);
      return;
    }

    // 3. Default AGE → хамгийн эхний насны ангилал
    if (!selectedAge && ageOptions.length) {
      setSelectedAge(ageOptions[0]);
    }
  }, [
    categoryList,
    typeOptions,
    genderOptions,
    ageOptions,
    selectedType,
    selectedGender,
    selectedAge,
  ]);

  const availableCategories = useMemo(
    () =>
      categoryList
        .filter((c) => !selectedType || c.type === selectedType)
        .filter((c) => !selectedGender || c.gender === selectedGender)
        .filter((c) => !selectedAge || c.age_division === selectedAge)
        .sort(
          (a, b) =>
            ageSortValue(a.age_division) -
              ageSortValue(b.age_division) ||
            weightSortValue(a.weightclass_name) -
              weightSortValue(b.weightclass_name) ||
            String(a.weightclass_name || "").localeCompare(
              String(b.weightclass_name || ""),
              undefined,
              { numeric: true }
            )
        ),
    [categoryList, selectedType, selectedGender, selectedAge]
  );

    useEffect(() => {
    if (!availableCategories.length) return;

    // Filter-үүд бүрэн default болсон хойно weight сонгоно
    if (!selectedType || !selectedGender) return;
    if (ageOptions.length > 0 && !selectedAge) return;

    const stillAvailable = availableCategories.some(
      (category) =>
        String(category.category_id) === String(selectedCategory)
    );

    if (!stillAvailable) {
      const nextCategory = String(
        availableCategories[0].category_id
      );

      setSelectedCategory(nextCategory);
      setSearchParams(
        { category: nextCategory },
        { replace: true }
      );
    }
  }, [
    availableCategories,
    selectedCategory,
    selectedType,
    selectedGender,
    selectedAge,
    ageOptions,
    setSearchParams,
  ]);

    const handleCategorySelect = (categoryId) => {
      const value = String(categoryId);
      setSelectedCategory(value);
      setSearchParams({ category: value }, { replace: true });
    };

    const activeCategory =
      categoryList.find((c) => String(c.category_id) === String(selectedCategory)) ||
      availableCategories[0] ||
      null;

    const activeRoundsData = activeCategory?.rounds || [];

    const finalMatch = activeRoundsData.length
      ? activeRoundsData[activeRoundsData.length - 1]?.[0]
      : null;

    const championId = getWinnerId(finalMatch);

    const champion = useMemo(() => {
  if (!championId || !finalMatch) return null;

  const slot =
    Number(championId) === Number(getFighterId(finalMatch, 1))
      ? 1
      : 2;

  const prefix = slot === 1 ? "fighter1" : "fighter2";
  const fighter = finalMatch[prefix] || {};

  return {
    fighter_id: championId,

    name: getFighterName(finalMatch, slot),

    club_name: getClubName(finalMatch, slot),

    club_logo:
      finalMatch?.[`${prefix}_club_logo`] ||
      fighter?.club_logo ||
      "",

    photo_url: getFighterPhoto(finalMatch, slot),
  };
}, [championId, finalMatch]);

    const handleSelectWinner = async (match, winnerId) => {
      const matchId = match?.match_id ?? match?.id;
      const bracketId = match?.bracket_id ?? activeCategory?.bracket_id;
      if (!matchId || !bracketId || !winnerId) return;

      if (!window.confirm("Энэ тамирчныг ялагчаар баталгаажуулж дараагийн шатанд оруулах уу?")) {
        return;
      }

      try {
        setSavingWinner(matchId);
        await API.post(`/brackets/${bracketId}/update-winner`, {
          match_id: matchId,
          winner_id: winnerId,
        });
        await fetchBrackets(true);
      } catch (err) {
        console.error("Winner update error:", err);
        alert(
          err?.response?.data?.error ||
            err?.response?.data?.message ||
            "Ялагч бүртгэхэд алдаа гарлаа."
        );
      } finally {
        setSavingWinner(null);
      }
    };

    const handleChangeResult = async (match) => {
      const matchId = match?.match_id ?? match?.id;
      const bracketId = match?.bracket_id ?? activeCategory?.bracket_id;
      if (!matchId || !bracketId) return;

      if (!window.confirm("Энэ тулааны үр дүнг өөрчлөх үү? Хэрэв дараагийн шат эхэлсэн бол систем өөрчлөлтийг зөвшөөрөхгүй.")) {
        return;
      }

      try {
        setSavingWinner(matchId);
        await API.post(`/brackets/${bracketId}/revert-winner`, {
          match_id: matchId,
        });
        await fetchBrackets(true);
      } catch (err) {
        console.error("Change result error:", err);
        alert(
          err?.response?.data?.error ||
            err?.response?.data?.message ||
            "Үр дүнг өөрчлөх боломжгүй байна."
        );
      } finally {
        setSavingWinner(null);
      }
    };

    const shareBracket = async ({ name, club, facebook = false } = {}) => {
      const shareUrl = new URL(window.location.href);
      const shareCategoryId = activeCategory?.category_id ?? selectedCategory;
      if (shareCategoryId) shareUrl.searchParams.set("category", String(shareCategoryId));
      const url = shareUrl.toString();
      const title = name ? `${name} — WAR FC Champion` : "WAR FC Tournament Bracket";
      const text = name
        ? `🏆 ${name}${club ? ` — ${club}` : ""} became champion! ${title}`
        : "WAR FC Tournament Bracket";

      if (facebook) {
        const shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`;
        window.open(shareUrl, "warfc-facebook-share", "width=700,height=650,noopener,noreferrer");
        return;
      }

      if (navigator.share) {
        try {
          await navigator.share({ title, text, url });
          return;
        } catch (err) {
          if (err?.name === "AbortError") return;
        }
      }

      try {
        await navigator.clipboard.writeText(url);
        alert("Bracket-ийн холбоос хууллаа. Facebook, Instagram зэрэгт шууд paste хийгээрэй.");
      } catch {
        window.prompt("Bracket холбоос:", url);
      }
    };

    const resetType = (type) => {
    setSelectedType(type);
    setSelectedGender("");
    setSelectedAge("");
  };

  const resetGender = (gender) => {
    setSelectedGender(gender);
    setSelectedAge("");
  };

    if (loading) {
      return (
        <div className="min-h-screen bg-black text-white flex items-center justify-center pt-24">
          <div className="text-center">
            <div className="w-12 h-12 rounded-full border-4 border-neutral-800 border-t-[#d4af37] animate-spin mx-auto" />
            <p className="mt-5 text-[#d4af37] text-[10px] font-black uppercase tracking-[0.3em]">
              Bracket ачааллаж байна...
            </p>
          </div>
        </div>
      );
    }

    const getTypeButtonClass = (type, active) => {
    if (type === "altan_garaa") {
      return active
        ? "bg-[#d4af37] text-black border-[#f4d35e] shadow-[0_0_20px_rgba(212,175,55,0.25)]"
        : "bg-[#d4af37]/10 text-[#e8c968] border-[#d4af37]/30 hover:bg-[#d4af37]/20";
    }

    return active
      ? "bg-white text-black border-white shadow-[0_0_18px_rgba(255,255,255,0.14)]"
      : "bg-white/[0.04] text-neutral-300 border-neutral-700 hover:border-white/40 hover:bg-white/[0.08]";
  };

  const getGenderButtonClass = (gender, active) => {
    if (gender === "male") {
      return active
        ? "bg-blue-500 text-white border-blue-400 shadow-[0_0_20px_rgba(59,130,246,0.35)]"
        : "bg-blue-500/10 text-blue-300 border-blue-500/30 hover:bg-blue-500/20";
    }

    if (gender === "female") {
      return active
        ? "bg-pink-500 text-white border-pink-400 shadow-[0_0_20px_rgba(236,72,153,0.35)]"
        : "bg-pink-500/10 text-pink-300 border-pink-500/30 hover:bg-pink-500/20";
    }

    return active
      ? "bg-white text-black border-white"
      : "bg-white/[0.04] text-neutral-300 border-neutral-700";
  };

  const getAgeButtonClass = (active) =>
    active
      ? "bg-violet-500 text-white border-violet-400 shadow-[0_0_18px_rgba(139,92,246,0.30)]"
      : "bg-violet-500/10 text-violet-300 border-violet-500/30 hover:bg-violet-500/20";

  const getWeightButtonClass = (active) =>
    active
      ? "bg-emerald-500 text-black border-emerald-300 shadow-[0_0_22px_rgba(16,185,129,0.28)]"
      : "bg-emerald-500/[0.08] text-emerald-300 border-emerald-500/30 hover:bg-emerald-500/15";

    return (
      <div className="min-h-screen bg-[#030303] text-white pt-24 pb-20 overflow-x-hidden">
        <div className="fixed inset-0 pointer-events-none opacity-60">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[900px] h-[420px] bg-[#d4af37]/[0.045] blur-[150px]" />
          <div className="absolute bottom-0 left-0 w-[500px] h-[350px] bg-red-950/10 blur-[130px]" />
        </div>

        <header className="relative z-10 max-w-[1500px] mx-auto px-4 md:px-6 pt-5 pb-8">
          <Link
            to="/tournaments"
            className="inline-flex items-center gap-2 text-neutral-500 hover:text-[#d4af37] text-[10px] font-black uppercase tracking-[0.18em] transition"
          >
            ← Тэмцээнүүд
          </Link>

          <div className="mt-6 flex flex-col lg:flex-row lg:items-end lg:justify-between gap-5">
            <div>
              <div className="text-[#d4af37] text-[10px] font-black tracking-[0.4em] uppercase">
                WAR FC • OFFICIAL RESULTS
              </div>
              <h1 className="mt-2 text-4xl md:text-6xl font-black italic uppercase tracking-tight">
                TOURNAMENT <span className="text-[#d4af37]">BRACKETS</span>
              </h1>
              <p className="mt-2 text-neutral-600 text-[10px] font-bold uppercase tracking-[0.25em]">
                Single Elimination • Live Progression • Official Winners
              </p>
            </div>
          </div>
        </header>

        <main className="relative z-10 max-w-[1500px] mx-auto px-4 md:px-6">
          {error && (
            <div className="mb-6 rounded-xl border border-red-900/60 bg-red-950/30 px-4 py-3 text-red-300 text-xs font-bold">
              {error}
            </div>
          )}

          {categoryList.length > 0 && (
            <section className="mb-8">

    {/* TYPE + GENDER */}
    <div className="flex flex-col lg:flex-row lg:items-center gap-3">

      {/* TYPE */}
      <div className="flex w-full lg:w-auto rounded-xl border border-white/10 bg-white/[0.035] p-1 backdrop-blur-md">

        {typeOptions.map((type) => {
          const active = selectedType === type;
          const isAltan = type === "altan_garaa";

          return (
            <button
              key={type}
              type="button"
              onClick={() => resetType(type)}
              className={`
                relative flex-1 lg:flex-none px-5 lg:px-7 py-3.5
                text-[10px] md:text-[11px]
                font-black uppercase tracking-[0.12em]
                rounded-lg
                transition-all duration-300
                whitespace-nowrap
                ${
                    active
    ? isAltan
      ? "bg-[#d4af37] text-black shadow-[0_0_24px_rgba(212,175,55,0.28)]"
      : "bg-[#00B8C8] text-black shadow-[0_0_26px_rgba(0,184,200,0.32)]"
                    : "text-neutral-500 hover:text-white hover:bg-white/[0.045]"
                }
              `}
            >
              {typeLabel(type)}
            </button>
          );
        })}
      </div>


      {/* GENDER */}
      <div className="flex w-full lg:w-auto rounded-xl border border-white/10 bg-white/[0.035] p-1 backdrop-blur-md">

        {genderOptions.map((gender) => {
          const active = selectedGender === gender;
          const male = gender === "male";

          return (
            <button
              key={gender}
              type="button"
              onClick={() => resetGender(gender)}
              className={`
                relative flex-1 lg:flex-none px-5 lg:px-7 py-3.5
                text-[10px] md:text-[11px]
                font-black uppercase tracking-[0.12em]
                rounded-lg
                transition-all duration-300
                whitespace-nowrap
                ${
                  active
                  ? male
    ? "bg-[#00B8C8] text-black shadow-[0_0_26px_rgba(0,184,200,0.32)]"
    : "bg-[#ff2d8d] text-black shadow-[0_0_26px_rgba(255,45,141,0.30)]"
                    : "text-neutral-500 hover:text-white hover:bg-white/[0.045]"
                }
              `}
            >
              {male ? "♂ " : "♀ "}
              {genderLabel(gender)}
            </button>
          );
        })}
      </div>

    </div>


    {/* AGE */}
    {ageOptions.length > 0 && (
      <div className="mt-5 flex items-center gap-2 overflow-x-auto pb-2 scrollbar-thin">

        {ageOptions.map((age) => {
          const active = selectedAge === age;

          return (
            <button
              key={age}
              type="button"
              onClick={() => setSelectedAge(age)}
              className={`
                relative shrink-0
                min-w-[82px]
                px-5 py-3.5
                rounded-lg
                border
                text-[11px] md:text-[12px]
                font-black
                tracking-[0.04em]
                whitespace-nowrap
                transition-all duration-250
                ${
                  active
    ? "border-white bg-white text-black shadow-[0_0_22px_rgba(255,255,255,0.18)]"
                    : "border-white/[0.07] bg-white/[0.025] text-neutral-500 hover:border-white/20 hover:bg-white/[0.045] hover:text-white"
                }
              `}
            >
              {age}

            </button>
          );
        })}

      </div>
    )}


    {/* WEIGHT */}
    <div className="mt-5 flex gap-2 overflow-x-auto pb-2 scrollbar-thin">

      {availableCategories.map((category) => {
        const active =
          String(category.category_id) === String(selectedCategory);

        return (
          <button
            key={category.category_id}
            type="button"
            onClick={() =>
              handleCategorySelect(category.category_id)
            }
            className={`
              group relative shrink-0
              min-w-[82px] sm:min-w-[92px]
  px-4 sm:px-5 py-3
              rounded-xl
              border
              transition-all duration-300
              ${
                active
    ? "border-[#d4af37] bg-[#d4af37] text-black shadow-[0_0_28px_rgba(212,175,55,0.28)]"
                  : "border-white/[0.07] bg-white/[0.025] text-neutral-500 hover:border-white/20 hover:text-white"
              }
            `}
          >

            <div
              className={`
                text-sm font-black tracking-tight
                ${
                  active
    ? "text-black"
    : "text-neutral-400 group-hover:text-white"
                }
              `}
            >
              {category.weightclass_name}
            </div>

          </button>
        );
      })}

    </div>

  </section>
          )}

          {!activeCategory || !activeRoundsData.length ? (
            <div className="max-w-xl mx-auto py-20 text-center rounded-2xl border border-neutral-800 bg-neutral-950/60">
              <div className="text-4xl mb-4">⚔️</div>
              <div className="text-neutral-300 text-sm font-black uppercase">Bracket одоогоор бэлэн болоогүй байна</div>
              <div className="mt-2 text-neutral-600 text-[10px] font-bold uppercase tracking-wider">
                Админ bracket үүсгэсний дараа энд харагдана.
              </div>
            </div>
          ) : (
            <section>
              <div className="flex flex-col xl:flex-row gap-7 items-start">
                <div className="min-w-0 flex-1 w-full">
                  <div className="rounded-2xl border border-neutral-800 bg-neutral-950/60 p-4 md:p-5 mb-5">
                    <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4">
                      <div>
                        <div className="text-[9px] font-black uppercase tracking-[0.28em] text-[#d4af37]">
                          {typeLabel(activeCategory.type)}
                        </div>
                        <h2 className="mt-2 text-2xl md:text-3xl font-black italic uppercase">
                          {genderLabel(activeCategory.gender)} <span className="text-neutral-700">•</span> {activeCategory.age_division} <span className="text-neutral-700">•</span> {activeCategory.weightclass_name}
                        </h2>
                        <div className="mt-2 flex flex-wrap gap-3 text-[9px] font-black uppercase tracking-widest text-neutral-600">
                          <span>⚔️ {activeRoundsData.flat().reduce((count, match) => count + (getFighterId(match, 1) ? 1 : 0) + (getFighterId(match, 2) ? 1 : 0), 0)} fighter slots</span>
                          <span>•</span>
                          <span>{activeRoundsData.length} rounds</span>
                          {championId && <><span>•</span><span className="text-emerald-400">CHAMPION CROWNED</span></>}
                        </div>
                      </div>

                      <button
                        type="button"
                        onClick={() => shareBracket({ name: champion?.name, club: champion?.club_name })}
                        className="shrink-0 rounded-xl border border-neutral-700 px-4 py-3 text-[9px] font-black uppercase tracking-widest text-neutral-300 hover:border-[#d4af37]/50 hover:text-[#d4af37] transition"
                      >
                        ↗ SHARE THIS DIVISION
                      </button>
                    </div>
                  </div>

                  {/* =========================================================
      PROFESSIONAL SINGLE-ELIMINATION BRACKET
    ========================================================= */}

  <div className="rounded-2xl border border-neutral-900 bg-black/40 p-3 md:p-5 shadow-2xl overflow-x-auto">

    {(() => {
      const totalRounds = activeRoundsData.length;

      if (!totalRounds) return null;

      const firstRoundMatches =
        activeRoundsData[0]?.length || 1;

      /*
        Total canvas height is determined by Round 1.

        Every later round is mathematically centered
        between the two fights feeding into it.
      */
      const bracketHeight =
        BRACKET_TOP * 2 +
        BRACKET_CARD_HEIGHT +
        (firstRoundMatches - 1) * BRACKET_STEP;

      const bracketWidth =
        totalRounds * BRACKET_CARD_WIDTH +
        (totalRounds - 1) * BRACKET_COLUMN_GAP;

      return (
        <div
          className="relative mx-auto"
          style={{
            width: `${bracketWidth}px`,
            height: `${bracketHeight}px`,
          }}
        >

          {/* =====================================================
              CONNECTOR LINES
            ===================================================== */}

          <svg
            className="absolute inset-0 z-0 pointer-events-none"
            width={bracketWidth}
            height={bracketHeight}
            viewBox={`0 0 ${bracketWidth} ${bracketHeight}`}
            fill="none"
          >

            {activeRoundsData
              .slice(0, -1)
              .map((roundMatches, roundIdx) => {

                const nextRoundMatches =
                  activeRoundsData[roundIdx + 1] || [];

                /*
                  Position math for current round
                */
                const currentStep =
                  BRACKET_STEP *
                  Math.pow(2, roundIdx);

                const currentOffset =
                  (BRACKET_STEP *
                    (Math.pow(2, roundIdx) - 1)) /
                  2;

                const currentColumnX =
                  roundIdx *
                  (BRACKET_CARD_WIDTH + BRACKET_COLUMN_GAP);

                const nextColumnX =
                  (roundIdx + 1) *
                  (BRACKET_CARD_WIDTH + BRACKET_COLUMN_GAP);

                const currentRightX =
                  currentColumnX +
                  BRACKET_CARD_WIDTH;

                const connectorX =
                  currentRightX +
                  BRACKET_COLUMN_GAP / 2;

                return roundMatches.map(
                  (match, matchIndex) => {

                    /*
                      Only create connector for the
                      first fight in each pair.
                    */
                    if (matchIndex % 2 !== 0) {
                      return null;
                    }

                    const topMatch =
                      roundMatches[matchIndex];

                    const bottomMatch =
                      roundMatches[matchIndex + 1];

                    const nextMatch =
                      nextRoundMatches[
                        Math.floor(matchIndex / 2)
                      ];

                    /*
                      Vertical center of top fight
                    */
                    const topY =
                      BRACKET_TOP +
                      currentOffset +
                      matchIndex * currentStep +
                      BRACKET_CARD_HEIGHT / 2;

                    /*
                      Vertical center of bottom fight
                    */
                    const bottomY = bottomMatch
                      ? BRACKET_TOP +
                        currentOffset +
                        (matchIndex + 1) *
                          currentStep +
                        BRACKET_CARD_HEIGHT / 2
                      : topY;

                    /*
                      Center point where the two
                      previous fights join.
                    */
                    const nextY =
                      (topY + bottomY) / 2;

                    /*
                      Winner propagation
                    */
                    const topWinner =
                      getWinnerId(topMatch);

                    const bottomWinner =
                      bottomMatch
                        ? getWinnerId(bottomMatch)
                        : null;

                    /*
                      Check whether the winner has
                      actually propagated into next match.
                    */
                    const topWinnerAdvanced =
                      topWinner &&
                      nextMatch &&
                      (
                        Number(
                          getFighterId(nextMatch, 1)
                        ) === Number(topWinner) ||
                        Number(
                          getFighterId(nextMatch, 2)
                        ) === Number(topWinner)
                      );

                    const bottomWinnerAdvanced =
                      bottomWinner &&
                      nextMatch &&
                      (
                        Number(
                          getFighterId(nextMatch, 1)
                        ) === Number(bottomWinner) ||
                        Number(
                          getFighterId(nextMatch, 2)
                        ) === Number(bottomWinner)
                      );

                    const pathActive =
                      !!(
                        topWinnerAdvanced ||
                        bottomWinnerAdvanced
                      );

                    const lineColor = pathActive
                      ? "#d4af37"
                      : "#3f3f46";

                    const lineWidth = pathActive
                      ? 2.2
                      : 1.4;

                    return (
                      <g
                        key={`connector-${roundIdx}-${matchIndex}`}
                      >

                        {/* =====================================
                            TOP FIGHT → CENTER
                          ===================================== */}

                        <line
                          x1={currentRightX}
                          y1={topY}
                          x2={connectorX}
                          y2={topY}
                          stroke={lineColor}
                          strokeWidth={lineWidth}
                          strokeLinecap="round"
                          opacity={
                            pathActive ? 0.9 : 0.55
                          }
                        />


                        {/* =====================================
                            BOTTOM FIGHT → CENTER
                          ===================================== */}

                        {bottomMatch && (
                          <line
                            x1={currentRightX}
                            y1={bottomY}
                            x2={connectorX}
                            y2={bottomY}
                            stroke={lineColor}
                            strokeWidth={lineWidth}
                            strokeLinecap="round"
                            opacity={
                              pathActive
                                ? 0.9
                                : 0.55
                            }
                          />
                        )}


                        {/* =====================================
                            VERTICAL JOIN
                          ===================================== */}

                        {bottomMatch && (
                          <line
                            x1={connectorX}
                            y1={topY}
                            x2={connectorX}
                            y2={bottomY}
                            stroke={lineColor}
                            strokeWidth={lineWidth}
                            strokeLinecap="round"
                            opacity={
                              pathActive
                                ? 0.9
                                : 0.55
                            }
                          />
                        )}


                        {/* =====================================
                            CENTER → NEXT ROUND
                          ===================================== */}

                        <line
                          x1={connectorX}
                          y1={nextY}
                          x2={nextColumnX}
                          y2={nextY}
                          stroke={lineColor}
                          strokeWidth={lineWidth}
                          strokeLinecap="round"
                          opacity={
                            pathActive ? 0.9 : 0.55
                          }
                        />

                      </g>
                    );
                  }
                );
              })}

          </svg>


          {/* =====================================================
              ROUND COLUMNS + MATCHES
            ===================================================== */}

          {activeRoundsData.map(
            (roundMatches, roundIdx) => {

              const isFinal =
                roundIdx === totalRounds - 1;

              const roundsFromFinal =
                totalRounds - 1 - roundIdx;

              const roundTitle =
                roundsFromFinal === 0
                  ? "FINAL"
                  : roundsFromFinal === 1
                  ? "SEMIFINALS"
                  : roundsFromFinal === 2
                  ? "QUARTERFINALS"
                  : `ROUND OF ${Math.pow(
                      2,
                      roundsFromFinal + 1
                    )}`;

              /*
                Exact vertical positioning.

                Round 1:
                match spacing = normal

                Round 2:
                spacing = 2x

                Round 3:
                spacing = 4x

                Round 4:
                spacing = 8x
              */
              const roundStep =
                BRACKET_STEP *
                Math.pow(2, roundIdx);

              /*
                Center the entire next round
                between the previous round's fights.
              */
              const roundOffset =
                (BRACKET_STEP *
                  (Math.pow(2, roundIdx) - 1)) /
                2;

              const columnLeft =
                roundIdx *
                (BRACKET_CARD_WIDTH +
                  BRACKET_COLUMN_GAP);

              return (
                <div
                  key={`round-${roundIdx}`}
                  className="absolute top-0"
                  style={{
                    left: `${columnLeft}px`,
                    width: `${BRACKET_CARD_WIDTH}px`,
                  }}
                >

                  {/* =========================================
                      ROUND TITLE
                    ========================================= */}

                  <div
                    className={`
                      absolute
                      top-0
                      left-0
                      w-full
                      h-8
                      flex
                      items-center
                      justify-center
                      rounded-lg
                      border
                      text-[9px]
                      font-black
                      uppercase
                      tracking-[0.2em]
                      ${
                        isFinal
                          ? "border-[#d4af37]/70 bg-[#d4af37]/10 text-[#d4af37]"
                          : "border-white/[0.07] bg-white/[0.025] text-neutral-500"
                      }
                    `}
                  >
                    {roundTitle}
                  </div>


                  {/* =========================================
                      MATCHES
                    ========================================= */}

                  {roundMatches.map(
                    (match, matchIndex) => {

                      /*
                        Exact top position
                      */
                      const top =
                        BRACKET_TOP +
                        roundOffset +
                        matchIndex *
                          roundStep;

                      const matchWinner =
                        getWinnerId(match);

                      return (
                        <div
                          key={
                            match.match_id ??
                            match.id ??
                            `${roundIdx}-${matchIndex}`
                          }
                          className="absolute left-0"
                          style={{
                            top: `${top}px`,
                          }}
                        >

                          <MatchCard
                            match={match}
                            roundIndex={roundIdx}
                            totalRounds={totalRounds}
                            isAdmin={isAdmin}
                            savingWinner={savingWinner}
                            onSelectWinner={
                              handleSelectWinner
                            }
                            onChangeResult={
                              handleChangeResult
                            }
                            pathActive={
                              matchWinner != null
                            }
                          />

                        </div>
                      );
                    }
                  )}

                </div>
              );
            }
          )}

        </div>
      );
    })()}

  </div>
                </div>

                <ChampionPanel
                  champion={champion}
                  category={activeCategory}
                  onShare={shareBracket}
                />
              </div>
            </section>
          )}
        </main>
      </div>
    );
  }
